module.exports = __webpack_public_path__ + "static/media/suisseintl-semibold-webm.eca61528.woff2";